import { Response } from "../../types/Response.interface";
import { apiClient } from "../../utils/apiClient";

interface AuthAPI {
  res: Response | null;
  featured: Response | null;
}

const autApi = async (): Promise<AuthAPI> => {
  try {
    if (localStorage.getItem("token")) {
      const res: Response = await apiClient.get("/api/v1/auth/profile");
      if (res.ok) {
        const featured: Response = await apiClient.get("/api/v1/featured/mls");

        if (featured.ok) {
          return {
            res,
            featured,
          };
        }

        return {
          res,
          featured: null,
        };
      }
    }

    return { featured: null, res: null };
  } catch (error) {
    return { featured: null, res: null };
  }
};

export default autApi;
